import { gql } from '@apollo/client';

export const EXPOSURE_RELATED_DOCUMENTS = gql`
  fragment exposureRelatedDocuments on ExposureRelatedDocuments {
    exposureDocuments {
      id
      document {
        id
        url
        name
        filename
      }
      client {
        id
        name
      }
      vehicle {
        id
        vin
        unitNumber
      }
      insured {
        id
        email
      }
    }
    documentRelationships {
      id
      source
      document {
        id
        url
        name
        filename
      }
      client {
        id
        name
      }
      vehicle {
        id
        vin
        unitNumber
      }
      insured {
        id
        email
      }
      clientDocument {
        id
        effectiveDate
        expirationDate
      }
      policyDocument {
        id
        effectiveDate
        expirationDate
      }
      productDocument {
        id
        effectiveDate
        expirationDate
      }
    }
  }
`;

export const GET_ELECTION_DOCUMENTS = gql`
  query ElectionDocuments($id: ID!) {
    election: getExposureElection(id: $id) {
      id
      compliance {
        inCompliance
        rejected
        violations {
          id
          type
          source
          status
          field
          reason
          value
        }
      }
      documents {
        ...exposureRelatedDocuments
      }
    }
  }
  ${EXPOSURE_RELATED_DOCUMENTS}
`;
